<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-tabs >
        <a-tab-pane key="1" tab="同步内容">
          <syncContent></syncContent>
        </a-tab-pane>
        <a-tab-pane key="2" tab="同步记录">
          <syncList></syncList>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted,inject,reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import syncList from './components/syncList';
import syncContent from './components/syncContent';
export default {
  components: {syncList,syncContent },
  setup(props) {
    const state = reactive({

    });
    const $router = inject('$router')
    const $Modal = inject('$Modal')
    
    onMounted(() => {
    });
    return {
      ...toRefs(state)
    };
  },
};
</script>